<div
  (click)="this.handleMenuClick.emit($event)"
  [ngClass]="{
    'portal-menu--horizontal': isHorizontal && !isMobile,
    'layout-sidebar': !isHorizontal || isMobile
  }"
>
  <a [routerLink]="['/']" class="logo m-0 p-0" title="Go to Dashboard">
    <img
      *ngIf="selectedEntityDetails?.images?.length; else noCustomImage"
      [alt]="selectedEntityDetails?.name || 'Portal'"
      [src]="
        selectedEntityDetails.images[0].sizes?.length > 1
          ? (selectedEntityDetails.images
            | getFirstAvailableImageForSize: '200')
          : selectedEntityDetails.images[0].url
      "
      class="logo-image"
      id="app-logo"
    />

    <ng-template #noCustomImage>
      <img
        alt="Boma"
        class="logo-image wider-logo"
        id="app-logo"
        src="assets/layout/images/brand/logo-h-dark-text.svg"
      />
    </ng-template>

    <small *ngIf="tagLine" class="m-0 p-0" style="color: #777">{{
      tagLine
    }}</small>
  </a>

  <nav class="horizontal-nav" *ngIf="isHorizontal && !isMobile">
    <ul class="nav-list">
      <li *ngFor="let item of menuItems" class="nav-item">
        <a [routerLink]="item.routerLink" class="nav-link">{{ item.label }}</a>
        <ul *ngIf="item.items" class="dropdown">
          <li *ngFor="let subItem of item.items" class="dropdown-item">
            <a [routerLink]="subItem.routerLink" class="dropdown-link">{{
              subItem.label
            }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>

  <div
    class="layout-menu-container"
    style="color: #fff"
    *ngIf="!isHorizontal || isMobile"
  >
    <ng-container *ngIf="loaded; else loadingMenu">
      <ul
        *ngIf="adminDash || organizationPermissions; else noPermissions"
        class="layout-menu"
      >
        <ng-container *ngFor="let item of menuItems; let i = index">
          <ng-container>
            <li
              (setMenuHoverActive)="handleSetMenuHoverActive()"
              (setMenuHoverActiveFalse)="handleSetMenuHoverActiveFalse()"
              (staticMenuMobileActiveFalse)="staticMenuMobileActiveFalse()"
              (unblockBodyScroll)="unblockBodyScroll()"
              *ngIf="!item.separator"
              [index]="i"
              [isDesktop]="isDesktop"
              [isMobile]="isMobile"
              [isSlim]="isSlim"
              [item]="item"
              [menuHoverActive]="isMenuHoverActive"
              [organizationPermissions]="organizationPermissions"
              [root]="true"
              boma-portal-menu-item
            ></li>
          </ng-container>

          <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
      </ul>
      <ng-template #noPermissions>
        <p-messages severity="warn">
          <ng-template pTemplate>
            <span class="custom-message">
              You have no permissions, contact your company administrator to
              give you permissions.</span
            >
          </ng-template>
        </p-messages>
      </ng-template>
    </ng-container>
  </div>
  <ng-template #loadingMenu>
    Loading...
    <boma-anim-spinning-loader [size]="80"></boma-anim-spinning-loader>
  </ng-template>
</div>
